import { getCurrentProfileSelect } from '../get-current'
import { createSelector } from 'reselect'
import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getValueReduxUtil } from '../../../../redux/utils'
import { UNIT } from '../../../../../constant'

export const getWeightUnitProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.WEIGHT_UNIT) ||
    UNIT.IMPERIAL
)

export const isMetricWeightUnitProfileSelect = createSelector(
  getWeightUnitProfileSelect,
  profileWeightUnit => profileWeightUnit === UNIT.METRIC
)
